import React, { useState } from "react";
import { observer } from "mobx-react";

import { SportOfferContext } from "@gp/components";
import { SportOffer } from "@gp/offer";

import SportHeader from "./components/SportHeader";
import { TournamentEvents } from "./components/tournament-events/TournamentEvents";

export const PrematchSport = observer(function PrematchSport(props: {
	sport: SportOffer;
}) {
	const [isSportCollapsed, setIsSportCollapsed] = useState(false);

	return (
		<SportOfferContext.Provider value={props.sport}>
			<SportHeader
				isSportCollapsed={isSportCollapsed}
				setIsSportCollapsed={setIsSportCollapsed}
				sport={props.sport}
			/>
			{!isSportCollapsed &&
				props.sport.categories?.map((cat) =>
					cat.tournaments.map((tournament) => (
						<TournamentEvents
							key={tournament.id}
							sport={props.sport}
							category={cat}
							tournament={tournament}
						/>
					))
				)}
		</SportOfferContext.Provider>
	);
});
